import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import { Editor } from '@tinymce/tinymce-react'
import MergeTags from '~/pages/cp/includes/mergeTags/mergeTags'
import CampaignMergeTags from '../../../../../../includes/mergeTags/campaignMergeTags.jsx'
import FileManager from '~/pages/cp/includes/fileManager/fileManager'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import { connect } from 'react-redux'
import MPZColorPicker from './colorPickerComponent.jsx'
import MPZLinkPicker from './linkPickerComponent.jsx'
import DragDropFunctions from '../../../dragDropFunctions'
import AiContentGenerator from '../../../../../../includes/ai/contentGenerator'
import axios from '~/data/http/axios'
var timer
import i18n from '~/i18n'
@connect((store) => {
    return { user: store.user, siteMaster: store.siteMaster, accountMaster: store.accountMaster }
})
export default class WysiwygEditor extends Component {
    constructor(props) {
        super(props)
        this.state = {
            templateHTML: '',
            loaded: false,
            showColorPicker: false,
            colorPickerType: 'forecolor',
            lastColor: '',
            showLinkPicker: false,
            linkCurrVal: '',
            disableHidePickers: false,
            inlineDrawer: undefined,
            showAiCTA: true
        }
        this.handleEditorChange = this.handleEditorChange.bind(this)
        this.handleEditorCommand = this.handleEditorCommand.bind(this)
        this.openDrawer = this.openDrawer.bind(this)
        this.onMergeTagClick = this.onMergeTagClick.bind(this)
        this.pickNewColor = this.pickNewColor.bind(this)
        this.hideExternalPickers = this.hideExternalPickers.bind(this)
        this.pickNewLink = this.pickNewLink.bind(this)
        this.toggleHidePickers = this.toggleHidePickers.bind(this)
        this.clearContent = this.clearContent.bind(this)
        this.dismissAiCta = this.dismissAiCta.bind(this)
        this.onAiInsert = this.onAiInsert.bind(this)
    }
    componentDidMount() {
        //window.addEventListener("click", this.hideExternalPickers);
        //window.addEventListener("blur", this.hideExternalPickers)
        let showAiCTA = true
        if (
            this.props.user &&
            this.props.user.userData &&
            this.props.user.userData.firstLoad &&
            this.props.user.userData.firstLoad.dismissedDragDropAICTA
        ) {
            showAiCTA = false
        }
        this.setState({
            templateHTML: this.props.value,
            loaded: true,
            showAiCTA,
            selectionBookmark: null,
            selectedText: ''
        })
        //export functions
        if (this.props.clearContent) {
            this.props.clearContent(this.clearContent)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.hideExternalPickers)
        window.removeEventListener('blur', this.hideExternalPickers)
        clearTimeout(timer)
    }

    handleEditorCommand(e) {
        if (e.command === 'mpzFile') {
            this.openDrawer('fileManager')
        }
        if (e.command === 'mpzMergeTags') {
            this.openDrawer('mpzMergeTags')
        }
        if (e.command === 'mpzAiGenerator') {
            this.openDrawer('aiContentGenerator')
        }
        if (e.command === 'mpzColorPicker') {
            this.setState({ colorPickerType: 'forecolor' }, () => {
                this.openDrawer('mpzColorPicker', e)
            })
        }
        if (e.command === 'mpzColorPickerBG') {
            this.setState({ colorPickerType: 'bgcolor' }, () => {
                this.openDrawer('mpzColorPicker', e)
            })
        }
        if (e.command === 'mpzPickLink') {
            this.openDrawer('mpzPickLink', e)
        }
    }
    clearContent() {
        return this.refs.tinyMCEEditor.editor.editorCommands.execCommand('mceSetContent', '', '')
    }
    openDrawer(ourDrawer, e) {
        if (ourDrawer === 'fileManager') {
            var theDrawer = (
                <FileManager
                    onFileClick={(res) => {
                        this.onFileManagerClick(res.url)
                    }}
                    fileTypes={'all'}
                />
            )
            if (this.props.standalone) {
                this.setState({ inlineDrawer: theDrawer })
            } else {
                this.props.dispatch(
                    siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, true, '100vw', 'fix-height')
                )
            }
        }
        if (ourDrawer === 'mpzMergeTags') {
            var theDrawer = (
                <MergeTags
                    landingPage={this.props.isLandingPage}
                    campaign={this.props.campaign}
                    AutomationId={this.props.campaign ? this.props.campaign.AutomationId : undefined}
                    onTagClick={this.onMergeTagClick}
                />
            )

            if (
                this.props.additionalTools &&
                this.props.additionalTools.length &&
                this.props.additionalTools.indexOf('campaignMergeTags') > -1
            ) {
                theDrawer = (
                    <CampaignMergeTags
                        inDrawer={this.props.standalone}
                        AutomationId={this.props.AutomationId}
                        hasWorkflowEmails={this.props.hasWorkflowEmails}
                        includeSubscriber={true}
                        includeSubCustomFields={true}
                        insertMergeTag={this.onMergeTagClick}
                    />
                )
            }
            if (this.props.standalone) {
                this.setState({ inlineDrawer: theDrawer })
            } else {
                this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, true, '500px'))
            }
        }

        if (ourDrawer === 'mpzColorPicker') {
            this.setState({ showColorPicker: true, showLinkPicker: false })
        }
        if (ourDrawer === 'mpzPickLink') {
            this.setState({ showLinkPicker: true, showColorPicker: false, linkCurrVal: e.value ? e.value : '' })
        }
        if (ourDrawer === 'aiContentGenerator') {
            const editor = this.refs.tinyMCEEditor.editor
            let bookmark = null
            let selectedText = ''
            try {
                if (editor && editor.selection) {
                    bookmark = editor.selection.getBookmark(2, true)
                    selectedText = editor.selection.getContent({ format: 'text' }) || ''
                }
            } catch (err) {}
            this.setState({ selectionBookmark: bookmark, selectedText })

            var theDrawer = (
                <AiContentGenerator
                    contentType='paragraph'
                    selectedText={selectedText || undefined}
                    insertText={this.onAiInsert}
                    close={() => {
                        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
                    }}
                />
            )
            if (this.props.standalone) {
                this.setState({ inlineDrawer: theDrawer })
            } else {
                this.props.dispatch(
                    siteMaster.alterSiteDrawer(true, false, 'right', theDrawer, true, '700px', 'drawer_dark')
                )
            }
        }
    }

    onAiInsert(generatedHtml) {
        const editor = this.refs.tinyMCEEditor.editor
        try {
            if (this.state.selectionBookmark) {
                editor.selection.moveToBookmark(this.state.selectionBookmark)
            }
            editor.editorCommands.execCommand('mceInsertContent', false, generatedHtml)
        } finally {
            this.setState({ selectionBookmark: null })
            if (this.props.standalone) {
                this.setState({ inlineDrawer: undefined })
            } else {
                this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null))
            }
        }
    }

    pickNewColor(thisVal) {
        var newCol = thisVal
        if (typeof thisVal === 'object') {
            newCol = thisVal.hex
        }
        this.setState({ lastColor: newCol })
        clearTimeout(timer)
        let tmceColorType = 'ForeColor'
        if (this.state.colorPickerType === 'bgcolor') tmceColorType = 'HiliteColor'
        timer = setTimeout(() => {
            this.refs.tinyMCEEditor.editor.editorCommands.execCommand(tmceColorType, false, this.state.lastColor)
        }, 100)
    }

    pickNewLink(thisVal, target, title) {
        var linkAttrs = {
            href: thisVal,
            target: target,
            title: title
        }
        this.setState({ showLinkPicker: false, linkCurrVal: '' })
        this.refs.tinyMCEEditor.editor.editorCommands.execCommand('mceInsertLink', false, linkAttrs)
    }

    onMergeTagClick(tag) {
        this.refs.tinyMCEEditor.editor.editorCommands.execCommand('mceInsertContent', false, tag)
        if (this.props.standalone) {
            this.setState({ inlineDrawer: undefined })
        } else {
            this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null))
        }
    }

    handleEditorChange(content) {
        var self = this
        var content = content
        self.setState({ templateHTML: content })
        clearTimeout(timer)
        timer = setTimeout(() => {
            self.props.updateVal(self.props.path, content)
        }, 100)
    }

    hideExternalPickers(e) {
        if (this.state.disableHidePickers) {
            return
        }

        if (e && e.target) {
            if (e.target.className && e.target.className.indexOf('forecolor') > 1) return
            if (e.target.className && e.target.className.indexOf('-link') > 1) return
            if (e.target.children) {
                if (
                    e.target.firstChild &&
                    e.target.firstChild.className &&
                    e.target.firstChild.className.indexOf('-link') > 1
                )
                    return
            }
        }
        this.setState({ showColorPicker: false, showLinkPicker: false })
    }

    toggleHidePickers(doHide) {
        this.setState({ disableHidePickers: doHide })
    }

    dismissAiCta() {
        var firstLoad = { dismissedDragDropAICTA: false }
        if (
            (typeof this.props.user.userData.firstLoad === 'object') &
            (this.props.user.userData.firstLoad != undefined)
        ) {
            firstLoad = this.props.user.userData.firstLoad
        }
        if (firstLoad.dismissedDragDropAICTA && firstLoad.dismissedDragDropAICTA == true) return
        firstLoad.dismissedDragDropAICTA = true
        axios.put('/accountUser', { firstLoad: firstLoad })
        this.setState({ showAiCTA: false })
    }
    render() {
        if (!this.state.loaded) return <div></div>
        var advFontSizes = ''
        var xCnt = 8
        while (xCnt < 160) {
            advFontSizes += xCnt + 'px '
            xCnt += 1
        }
        var self = this
        advFontSizes = advFontSizes.substr(0, advFontSizes.length - 1)

        var style = { position: 'relative', width: '100%', flex: '100%' }
        var isSimple = false
        var toolBar = `code  bold italic underline strikethrough  mpzColorPicker mpzColorPickerBG  bullist numlist  outdent indent  ${!this.props.hideMergeTags && 'mpzMergeTags'}  mpzLinkPicker unlink anchor hr   alignleft aligncenter alignright alignjustify  formatselect styleselect fontsizeselect fontselect  removeformat lineheightselect`

        let bgColor = DragDropFunctions.getParentColor(this.props?.elementsData, this.props?.selectedElement?.path)
        let fgColor = ''
        if (this.props?.localVariables?.textColor?.value) {
            fgColor = this.props.localVariables.textColor.value
            if (fgColor && fgColor.indexOf('global_.') > -1) {
                fgColor = DragDropFunctions.replaceGlobalVariable(fgColor)
            }
            if (fgColor == bgColor) {
                if (bgColor.toLowerCase() == '#ffffff') {
                    fgColor = '#000000'
                } else if (bgColor.toLowerCase() == '#000000') {
                    fgColor = '#ffffff'
                } else {
                    fgColor = '#FFFFFF'
                }
            }
        }

        if (this.props.elementData) {
            if (this.props.elementData.wysiwygMode && this.props.elementData.wysiwygMode == 'simple') {
                isSimple = true
                toolBar = 'bold italic underline strikethrough'
            }
            if (this.props.elementData && this.props.elementData.wysiwygHeight) {
                style.height = this.props.elementData.wysiwygHeight
            }
        }

        if (this.props.wysiwygMode && this.props.wysiwygMode == 'simple') {
            isSimple = true
            toolBar = 'bold italic underline strikethrough'
        }

        if (
            this.props.additionalTools &&
            Array.isArray(this.props.additionalTools) &&
            this.props.additionalTools.length
        ) {
            this.props.additionalTools.forEach((tool) => {
                var toolName = tool
                if (toolName == 'campaignMergeTags') toolName = 'mpzMergeTags'
                toolBar += ' ' + toolName
            })
        }

        if (this.props.wysiwygHeight) {
            style.height = this.props.wysiwygHeight
        }

        if (this.props.error) {
            style.border = '1px solid red'
        }

        //work out background color
        var themeAdvancedFontsData = DragDropFunctions.lookupVariables('[OPTIONS.FONTARRAY]')
        var themeAdvancedFonts = ''
        let themeAdvancedFontsCSS = []
        themeAdvancedFontsData.forEach((f) => {
            themeAdvancedFonts += f.label + '=' + f.value + ';'
            themeAdvancedFontsCSS.push('https://fonts.googleapis.com/css?family=' + f.label.replace(/ /g, '+'))
        })

        let aiEnabled = this.props.siteMaster.siteId == 1
        if (!aiEnabled) aiEnabled = this.props.siteMaster.aiEnabled
        // let aiEnabled = false;
        // if (this.props.accountMaster.accountMaster.beta && this.props.accountMaster.accountMaster.beta.aiAssistant) aiEnabled = true;

        if (!isSimple) {
            var defaultFont = 'Arial'
            if (this.props.localVariables && this.props.localVariables.textFontFamily) {
                defaultFont = this.props.localVariables.textFontFamily.value
                defaultFont = DragDropFunctions.replaceGlobalVariable(defaultFont)
            }

            let h1 = {
                size: 24,
                weight: 'bold',
                lineHeight: 1.2,
                color: '#000000',
                font: defaultFont,
                fontStyle: 'normal'
            }
            let h2 = {
                size: 20,
                weight: 'bold',
                lineHeight: 1.2,
                color: '#000000',
                font: defaultFont,
                fontStyle: 'normal'
            }
            let h3 = {
                size: 18,
                weight: 'bold',
                lineHeight: 1.2,
                color: '#000000',
                font: defaultFont,
                fontStyle: 'normal'
            }
            let h4 = {
                size: 16,
                weight: 'bold',
                lineHeight: 1.2,
                color: '#000000',
                font: defaultFont,
                fontStyle: 'normal'
            }

            if (this.props?.elementsData?.globalVariables) {
                h1.size = this.props.elementsData.globalVariables.h1FontSize?.value || h1.size
                h1.weight = this.props.elementsData.globalVariables.h1FontWeight?.value || h1.weight
                h1.lineHeight = this.props.elementsData.globalVariables.h1LineHeight?.value || h1.lineHeight
                h1.font = this.props.elementsData.globalVariables.h1Font?.value || h1.font
                h1.color = this.props.elementsData.globalVariables.h1Color?.value || h1.color
                h1.fontStyle = this.props.elementsData.globalVariables.h1FontStyle?.value || h1.fontStyle

                h2.size = this.props.elementsData.globalVariables.h2FontSize?.value || h2.size
                h2.weight = this.props.elementsData.globalVariables.h2FontWeight?.value || h2.weight
                h2.lineHeight = this.props.elementsData.globalVariables.h2LineHeight?.value || h2.lineHeight
                h2.font = this.props.elementsData.globalVariables.h2Font?.value || h2.font
                h2.color = this.props.elementsData.globalVariables.h2Color?.value || h2.color
                h2.fontStyle = this.props.elementsData.globalVariables.h2FontStyle?.value || h2.fontStyle

                h3.size = this.props.elementsData.globalVariables.h3FontSize?.value || h3.size
                h3.weight = this.props.elementsData.globalVariables.h3FontWeight?.value || h3.weight
                h3.lineHeight = this.props.elementsData.globalVariables.h3LineHeight?.value || h3.lineHeight
                h3.font = this.props.elementsData.globalVariables.h3Font?.value || h3.font
                h3.color = this.props.elementsData.globalVariables.h3Color?.value || h3.color
                h3.fontStyle = this.props.elementsData.globalVariables.h3FontStyle?.value || h3.fontStyle

                h4.size = this.props.elementsData.globalVariables.h4FontSize?.value || h4.size
                h4.weight = this.props.elementsData.globalVariables.h4FontWeight?.value || h4.weight
                h4.lineHeight = this.props.elementsData.globalVariables.h4LineHeight?.value || h4.lineHeight
                h4.font = this.props.elementsData.globalVariables.h4Font?.value || h4.font
                h4.color = this.props.elementsData.globalVariables.h4Color?.value || h4.color
                h4.fontStyle = this.props.elementsData.globalVariables.h4FontStyle?.value || h4.fontStyle
            }

            return (
                <div>
                    {/* <div style={{ margin: "0", color: "#202432", opacity: "0.6", fontSize: "12px", textTransform: "uppercase", marginBottom: "10px" }}>{this.props.title}</div> */}
                    {aiEnabled == true && this.state.showAiCTA == true && (
                        <Paper className='paper_aiAssistant_cta'>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} className='mar-b15'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Icons
                                        square={true}
                                        color='#FFFFFF'
                                        icon='sparkle2'
                                        style={{ width: '25px', height: '25px' }}
                                        className='mar-r10'
                                    />
                                    <div className='text-heavy'>
                                        {i18n.t('templates:aiContentAssistant.promoHeader')}
                                    </div>
                                </div>
                                <div>
                                    <Icons icon='cross' color='#FFFFFF' onClick={this.dismissAiCta} />
                                </div>
                            </div>
                            <div className='mar-b20'>{i18n.t('templates:aiContentAssistant.promoBody')}</div>

                            <Button
                                className='button-darkmode-trans'
                                text={i18n.t('templates:aiContentAssistant.tryItOut')}
                                iconRight={<Icons color='#FFFFFF' icon='arrowRight' />}
                                onClick={() => {
                                    this.dismissAiCta()
                                    this.openDrawer('aiContentGenerator')
                                }}
                            />
                        </Paper>
                    )}

                    <div className='inlineTinyMce mce-noBottomBorder' style={style}>
                        <Editor
                            ref='tinyMCEEditor'
                            initialValue={this.state.templateHTML}
                            init={{
                                plugins:
                                    'image mpzMergeTags code advlist mpzColorPicker mpzLinkPicker textcolor  lists link paste spellchecker  hr anchor lineheight',
                                toolbar: toolBar,
                                browser_spellcheck: true,
                                width: '100%',
                                menubar: false,
                                height: '100%',
                                force_br_newlines: true,
                                force_p_newlines: false,
                                convert_urls: false,
                                forced_root_block: '',
                                imagetools_cors_hosts: [''],
                                imagetools_proxy: 'cdn1.ourmailsender.com',
                                imagetools_toolbar: 'imageoptions',

                                formats: [
                                    { title: 'Header 1', block: 'h1' },
                                    { title: 'Header 2', block: 'h2' },
                                    { title: 'Header 3', block: 'h3' },
                                    { title: 'Header 4', block: 'h4' }
                                ],
                                style_formats: [{ title: 'Table of Contents', selector: '*', classes: 'mp_toc_title' }],
                                block_formats: 'Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3; Heading 4=h4;',
                                fontsize_formats: advFontSizes,
                                font_formats: themeAdvancedFonts,
                                content_css: themeAdvancedFontsCSS,
                                forced_root_block: '',
                                init_instance_callback: function (editor) {
                                    editor.on('click', function (e) {
                                        self.hideExternalPickers(e)
                                    })
                                    editor.on('keyUp', function (e) {
                                        self.handleEditorChange(e.target.innerHTML)
                                    })
                                    editor.on('change', function (e) {
                                        self.handleEditorChange(editor.getContent())
                                    })
                                },
                                content_style: `body { font-family: ${defaultFont}; background-color: ${bgColor}; color: ${fgColor};
                            h1 { font-size: ${h1.size}; font-weight: ${h1.weight}; line-height: ${h1.lineHeight}; color: ${h1.color}; font-family: ${h1.font}; padding: 0; margin: 0; font-style: ${h1.fontStyle};};
                            h2 { font-size: ${h2.size}; font-weight: ${h2.weight}; line-height: ${h2.lineHeight}; color: ${h2.color}; font-family: ${h2.font}; padding: 0; margin: 0; font-style: ${h2.fontStyle};};
                            h3 { font-size: ${h3.size}; font-weight: ${h3.weight}; line-height: ${h3.lineHeight}; color: ${h3.color}; font-family: ${h3.font}; padding: 0; margin: 0; font-style: ${h3.fontStyle};};
                            h4 { font-size: ${h4.size}; font-weight: ${h4.weight}; line-height: ${h4.lineHeight}; color: ${h4.color}; font-family: ${h4.font}; padding: 0; margin: 0; font-style: ${h4.fontStyle}; };
                            `
                            }}
                            onExecCommand={(ed, param1, param2) => {
                                this.handleEditorCommand(ed)
                                this.handleEditorChange(ed.target.getContent())
                            }}
                        />

                        {this.state.showColorPicker == true && (
                            <div style={{ position: 'absolute', top: '45px', left: '140px' }}>
                                <MPZColorPicker
                                    color={this.state.lastColor}
                                    onChange={this.pickNewColor}
                                    disableAlpha={true}
                                    globalColours={this.props.globalColours}
                                    favoriteColors={this.props.favoriteColors}
                                    saveFaveColor={this.props.saveFaveColor}
                                />
                            </div>
                        )}

                        {this.state.showLinkPicker == true && (
                            <div style={{ position: 'absolute', top: '45px', right: '10px' }}>
                                <MPZLinkPicker
                                    standalone={this.props.standalone}
                                    save={this.pickNewLink}
                                    currVal={this.state.linkCurrVal}
                                    close={this.hideExternalPickers}
                                    toggleHidePickers={this.toggleHidePickers}
                                    elementsData={this.props.elementsData}
                                />
                            </div>
                        )}
                    </div>
                    {aiEnabled == true && (
                        <div className='tinyMce_bottomTools' style={{ backgroundColor: bgColor }}>
                            <div
                                className='tinyMce_bottomTools_aiAssistant border-darkmode-purple-to-blue-horizontal'
                                onClick={() => {
                                    this.dismissAiCta()
                                    this.openDrawer('aiContentGenerator')
                                }}
                                data-ph='ai-content-assistant-trigger-template-editor'
                            >
                                <Icons
                                    className='tinyMce_bottomTools_aiAssistant_icon'
                                    icon='sparkle2'
                                    color='#FFFFFF'
                                    style={{ width: '20px', height: '20px' }}
                                />
                                <div className='tinyMce_bottomTools_aiAssistant_label'>
                                    {i18n.t('templates:aiContentAssistant.aiContentAssistant')}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )
        }

        if (this.props.standalone) {
            return (
                <div className={this.props.outerClassName}>
                    <div className='dd_toolHolder' style={style}>
                        <div className='inlineTinyMce' style={style}>
                            <Editor
                                ref='tinyMCEEditor'
                                initialValue={this.state.templateHTML}
                                init={{
                                    plugins:
                                        'image mpzMergeTags code advlist mpzColorPicker mpzLinkPicker textcolor   link paste spellchecker  hr anchor ',
                                    toolbar: toolBar,
                                    browser_spellcheck: true,
                                    width: '100%',
                                    menubar: false,
                                    height: '100%',
                                    force_br_newlines: true,
                                    force_p_newlines: false,
                                    forced_root_block: false,
                                    convert_urls: false,
                                    convert_urls: false,
                                    imagetools_cors_hosts: [''],
                                    imagetools_proxy: 'cdn1.ourmailsender.com',
                                    imagetools_toolbar: 'imageoptions',
                                    formats: [
                                        { title: 'Header 1', block: 'h1' },
                                        { title: 'Header 2', block: 'h2' },
                                        { title: 'Header 3', block: 'h3' },
                                        { title: 'Header 4', block: 'h4' }
                                    ],

                                    content_style: '* { text-shadow: 1px 1px 1px #BBBBBB; }',
                                    fontsize_formats: advFontSizes,

                                    init_instance_callback: function (editor) {
                                        editor.on('click', function (e) {
                                            self.hideExternalPickers(e)
                                        })
                                        editor.on('keyDown', function (e) {
                                            if (e.keyCode === 13) {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                return false
                                            }
                                        })
                                        editor.on('keyUp', function (e) {
                                            self.handleEditorChange(e.target.innerHTML)
                                        })
                                    }
                                }}
                                onExecCommand={(ed) => {
                                    this.handleEditorCommand(ed)
                                }}
                                onChange={(e) => {
                                    this.handleEditorChange(e.target.getContent())
                                }}
                            />
                        </div>
                    </div>
                    {this.props.error && <FormError key={'err'}>{this.props.error}</FormError>}
                    {this.state.inlineDrawer && (
                        <Drawer
                            startClose={() => {
                                this.setState({ inlineDrawer: undefined })
                            }}
                            standalone={true}
                            isOpen={true}
                            width={500}
                            showClose={true}
                        >
                            {this.state.inlineDrawer}
                        </Drawer>
                    )}
                    {this.state.showColorPicker == true && (
                        <div style={{ position: 'absolute', top: '45px', left: '140px' }}>
                            <MPZColorPicker
                                color={this.state.lastColor}
                                onChange={this.pickNewColor}
                                disableAlpha={true}
                                globalColours={this.props.globalColours}
                                favoriteColors={this.props.favoriteColors}
                                saveFaveColor={this.props.saveFaveColor}
                            />
                        </div>
                    )}
                    {this.state.showLinkPicker == true && (
                        <div style={{ position: 'absolute', top: '45px', right: '10px' }}>
                            <MPZLinkPicker
                                standalone={this.props.standalone}
                                save={this.pickNewLink}
                                currVal={this.state.linkCurrVal}
                                close={this.hideExternalPickers}
                                toggleHidePickers={this.toggleHidePickers}
                                elementsData={this.props.elementsData}
                            />
                        </div>
                    )}
                </div>
            )
        }

        return (
            <div className='dd_toolHolder' style={style}>
                <div className='dd_inputTool'>
                    <p className='txtInput_label'>{this.props.title}</p>
                    <div className='inputWrapper'>
                        <div className='inlineTinyMce' style={style}>
                            <Editor
                                ref='tinyMCEEditor'
                                initialValue={this.state.templateHTML}
                                init={{
                                    plugins:
                                        'image mpzMergeTags code advlist mpzColorPicker mpzLinkPicker textcolor   link paste spellchecker  hr anchor ',
                                    toolbar: toolBar,
                                    browser_spellcheck: true,
                                    width: '100%',
                                    menubar: false,
                                    height: '100%',
                                    force_br_newlines: true,
                                    force_p_newlines: false,
                                    forced_root_block: false,
                                    convert_urls: false,
                                    convert_urls: false,
                                    imagetools_cors_hosts: [''],
                                    imagetools_proxy: 'cdn1.ourmailsender.com',
                                    imagetools_toolbar: 'imageoptions',
                                    formats: [
                                        { title: 'Header 1', block: 'h1' },
                                        { title: 'Header 2', block: 'h2' },
                                        { title: 'Header 3', block: 'h3' },
                                        { title: 'Header 4', block: 'h4' }
                                    ],

                                    fontsize_formats: advFontSizes,

                                    init_instance_callback: function (editor) {
                                        editor.on('click', function (e) {
                                            self.hideExternalPickers(e)
                                        })
                                        editor.on('keyDown', function (e) {
                                            if (e.keyCode === 13) {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                return false
                                            }
                                        })
                                        editor.on('keyUp', function (e) {
                                            self.handleEditorChange(e.target.innerHTML)
                                        })
                                    }
                                }}
                                onExecCommand={(ed) => {
                                    this.handleEditorCommand(ed)
                                }}
                                onChange={(e) => {
                                    this.handleEditorChange(e.target.getContent())
                                }}
                            />

                            {this.state.showColorPicker == true && (
                                <div style={{ position: 'absolute', top: '45px', left: '140px' }}>
                                    <MPZColorPicker
                                        color={this.state.lastColor}
                                        onChange={this.pickNewColor}
                                        disableAlpha={true}
                                        globalColours={this.props.globalColours}
                                        favoriteColors={this.props.favoriteColors}
                                        saveFaveColor={this.props.saveFaveColor}
                                    />
                                </div>
                            )}
                            {this.state.showLinkPicker == true && (
                                <div style={{ position: 'absolute', top: '45px', right: '10px' }}>
                                    <MPZLinkPicker
                                        standalone={this.props.standalone}
                                        save={this.pickNewLink}
                                        currVal={this.state.linkCurrVal}
                                        close={this.hideExternalPickers}
                                        toggleHidePickers={this.toggleHidePickers}
                                        elementsData={this.props.elementsData}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
